import MapWebModule from "@abaco/map-web-module/src/modules/map-web-module";
import GlobalStateModule from '@abaco/portal-global-state/src/modules/global-state';

import {
  AbacoWebModule,
  ApplicationReadyEvent,
  MenuItem,
  RouterReadyEvent,
  VueRouter
} from "@abaco/web-common/src/app";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import RiskAnalysesApi from "./api/RiskAnalysesApi";
import globals from "./globals";
import { createMenu } from "./menu";
import myRoutes from "./routes";
import RiskAnalysesVuexModule from "./state";
import Vue from "vue";

export const MODULE_ID = "risk_analyses";

export default class RiskAnalysesModule implements AbacoWebModule {
  public static MODULE_ID = MODULE_ID;

  private riskAnalysisBus!: Vue;
  private emergeAnlApi!: RiskAnalysesApi;
  private apiCreated = false;

  private router!: VueRouter;
  http!: HTTPClient;

  readonly id = MODULE_ID;
  readonly routes = myRoutes;
  readonly globalComponents = globals;
  readonly vuexModule = new RiskAnalysesVuexModule();

  dependsOn = {
    [MapWebModule.MODULE_ID]: () => new MapWebModule(),
    [GlobalStateModule.MODULE_ID]: () => new GlobalStateModule()
  };

  menu: MenuItem[] = [];

  constructor() {
    this.riskAnalysisBus = new Vue();
  }

  onRouterReady(evt: RouterReadyEvent) {
    this.router = evt.router;
    this.menu = createMenu(this.router);
  }

  onApplicationReady(evt: ApplicationReadyEvent) {
    this.http = evt.http;
  }

  async beforeEnterAnyRoutes(http: HTTPClient) {
    if (this.apiCreated) {
      return;
    }
    this.apiCreated = true;

    const RiskAnalysesApi = (await import("./api/RiskAnalysesApi")).default;
    this.emergeAnlApi = new RiskAnalysesApi(http);
  }

  public get riskAnalysesApi() {
    return this.emergeAnlApi;
  }

  public get eventBus() {
    return this.riskAnalysisBus
  }
}
